export default __webpack_public_path__ + "static/media/product-details-1.dbceaa6d.jpg";